export default __webpack_public_path__ + "static/mitech-client-logo-01-hover-21d2881210f424af125b135e9e296df9.png";